import Vue from "vue";

Vue.prototype.$contrafforte = [
  {
    key: "contrafforte0"
  },
  {
    key: "contrafforte1"
  },
  {
    key: "contrafforte2"
  },
  {
    key: "contrafforte3"
  },
  {
    key: "contrafforte4"
  },
  {
    key: "contrafforte5"
  },
  {
    key: "contrafforte6"
  },
  {
    key: "contrafforte7"
  },
  {
    key: "contrafforte8"
  },
  {
    key: "contrafforte9"
  }
];
